export default __webpack_public_path__ + "static/media/thumbnail2.5a9371b9.jpg";